import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = { class: "font-medium text-sm text-gray-900" };
const _hoisted_3 = { class: "mr-1.5 whitespace-nowrap" };
const _hoisted_4 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["Listbox"], {
            modelValue: $setup.selectedOption,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.selectedOption) = $event)),
            by: $props.by
        }, {
            default: _withCtx(({ open }) => [
                _createVNode($setup["ListboxButton"], {
                    ref: "listBoxButton",
                    class: "inline-flex w-full justify-center items-center gap-x-1 rounded-md bg-white px-2.5 py-1.5 text-sm text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString($setup.selectedOption?.label), 1 /* TEXT */),
                        _createVNode($setup["ChevronDownIcon"], {
                            class: "-mr-1 size-2 text-gray-400",
                            "aria-hidden": "true"
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */),
                _createVNode(_Transition, {
                    "enter-active-class": "transition duration-100 ease-out",
                    "enter-from-class": "transform scale-95 opacity-0",
                    "enter-to-class": "transform scale-100 opacity-100",
                    "leave-active-class": "transition duration-75 ease-out",
                    "leave-from-class": "transform scale-100 opacity-100",
                    "leave-to-class": "transform scale-95 opacity-0"
                }, {
                    default: _withCtx(() => [
                        _createVNode($setup["ListboxOptions"], { class: "absolute mt-2 overflow-auto right-0 rounded-md bg-white font-medium shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10" }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options, (option) => {
                                    return (_openBlock(), _createBlock($setup["ListboxOption"], {
                                        key: option.key,
                                        value: option
                                    }, {
                                        default: _withCtx(({ selected }) => [
                                            _createElementVNode("span", {
                                                class: _normalizeClass([
                                                    selected ? '' : ' hover:bg-gray-50 ',
                                                    'text-gray-900 block px-2.5 py-2',
                                                    'flex items-center justify-between hover:cursor-pointer',
                                                ])
                                            }, [
                                                _createElementVNode("span", _hoisted_3, _toDisplayString(option.label), 1 /* TEXT */),
                                                _createVNode($setup["CheckIcon"], {
                                                    class: _normalizeClass([selected ? '' : 'invisible', 'size-2 text-gray-900']),
                                                    "aria-hidden": "true"
                                                }, null, 8 /* PROPS */, ["class"])
                                            ], 2 /* CLASS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                ($setup.trackOpenState(open))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "by"])
    ]));
}
